import firebase from 'firebase'
//論理削除とするbool値のキー
const disabledFlg = 'disabled'
//ユーザランク取得処理
//bool 非ログイン(true)か否か
export const getUserRank = (userid,scope,bool,snapshot) => {
    //trustdockに登録済みか判定のあとポイント加算処理
    let isTrustdockResult = snapshot ? snapshot.hasOwnProperty('trustdockResult') : false

    //非ログインユーザーはfirebase,databaseのアクセス権がないのでAPIをたたいてpointsとuseridにひもづくscoresを取得する
    if(bool) {
      //ユーザーのスコアデータを取得
      let getUserScore = (uid,points) => {
        let xhr = new XMLHttpRequest()
        let scoreEval = 0
        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {
              //console.log(xhr.response)
              setScoreAndTags(points,JSON.parse(xhr.response),scoreEval)
            }
          }
        }
        xhr.open('POST','/api/getUserScore')
        xhr.setRequestHeader('Content-Type','application/json')
        xhr.send(JSON.stringify({uid:uid}))
      }
      let getPointsTable = (uid) => {
        let xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {
              //console.log(xhr.response)
              getUserScore(uid,JSON.parse(xhr.response),)
            }
          }
        }
        xhr.open('POST','/api/getPointsTable')
        xhr.setRequestHeader('Content-Type','application/json')
        xhr.send()
      }

      getPointsTable(userid)
    } else {
      firebase.database().ref("points").on("value", function(snapshot){
          var points = snapshot.val();
          firebase.database().ref("partners").on("value", function(PartnerRecord){
            var partners = PartnerRecord.val();
            //console.log(partners)
            firebase.database().ref("api_users_eval").orderByChild("uid").equalTo(userid).once('value').then((snap) => {
              var scoreEval = 0
              scoreEval = getPointEvalUser(snap, partners)
              // console.log(scoreEval)

              // ユーザーのスコアデータを取得
              var ref = firebase.database().ref("scores");
              ref.orderByChild("userid").equalTo(userid).on('value',(snapshot) => {
                setScoreAndTags(points,snapshot,scoreEval)
              });
            });
          });
      });
    }

    function getPointEvalUser (snapshot, partners) {
      let resultPoint = 0
      let domains = []
      let snap

      if(snapshot) {
        snap = typeof snapshot.val === 'function' ? snapshot.val() : snapshot
      } else {
        snap = {}
      }
      var ar = [];
      //連携解除フラグがたっていないオブジェクトのみを抽出
      for(let s in snap){
        if(snap.hasOwnProperty(s)) {
          ar.push(snap[s])
        }
      }

      Object.keys(ar).forEach((key) => {
        //console.log(ar[key].domain)
        if (domains.indexOf(ar[key].partner_id) === -1)　{
          domains.push(ar[key].partner_id)
        }
      })

      //サービスごとにグループ化
      let groups = {}

      let groupingDomains = (domainKey) => {
        groups[domainKey] = []
        Object.keys(ar).forEach((key) => {
          if(ar[key].partner_id === domainKey) {
            groups[domainKey].push(ar[key])
          }
        })
      }

      for(var d in domains) {
        if(domains.hasOwnProperty(d)) {
          groupingDomains(domains[d])
        }
      }

      //グループ毎に最新created_atを抽出し最新をもったオブジェクトをresultとして格納
      Object.keys(groups).forEach((key) => {
        let thisGroupNewestDate = Math.max.apply(null,groups[key].map((g) => {
          //console.log(g.created_at)
          let arr = g.created_at.split(/[- :]/)
          //console.log(arr)
          return Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]))
        }))

        for(let i in groups[key]){
          if(groups[key].hasOwnProperty(i)) {
            let arr = groups[key][i].created_at.split(/[- :]/)
            if(Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5])) === thisGroupNewestDate) {
              resultPoint += parseInt((groups[key][i].evals[0].value), 10)
            }
          }
        }
      })
      // console.log(resultPoint)
      return resultPoint
    }

    //scoresから取得してきたユーザーのscores情報を引数としてランク計算とタグをsetState
    function setScoreAndTags(points,snapshot,scoreEval){
      //console.log(points,snapshot)
      let snap
      if(snapshot) {
        snap = typeof snapshot.val === 'function' ? snapshot.val() : snapshot
      } else {
        snap = {}
      }
      var ar = [];
      //連携解除フラグがたっていないオブジェクトのみを抽出
      for(let s in snap){
          if(!snap[s].hasOwnProperty(disabledFlg)) {
              ar.push(snap[s])
          }
      }
      //console.log(ar)

      //各サービス最新一件だけを加算対象とする
      //ユーザーに紐づく連携対象ドメイン配列化
      let domains = []
      Object.keys(ar).forEach((key) => {
          //console.log(ar[key].domain)
          if (domains.indexOf(ar[key].domain) === -1)　{
              domains.push(ar[key].domain)
          }
      })
      //console.log(domains)

      //サービスごとにグループ化
      let groups = {}

      let groupingDomains = (domainKey) => {
          groups[domainKey] = []
          Object.keys(ar).forEach((key) => {
              if(ar[key].domain === domainKey) {
                  groups[domainKey].push(ar[key])
              }
          })
      }

      for(var d in domains) {
          groupingDomains(domains[d])
      }


      //console.log(groups)
      //グループ毎に最新created_atを抽出し最新をもったオブジェクトをresultとして格納
      let resultArr = []
      Object.keys(groups).forEach((key) => {
          let thisGroupNewestDate = Math.max.apply(null,groups[key].map((g) => {
              //console.log(g.created_at)
                  let arr = g.created_at.split(/[- :]/)
                  //console.log(arr)
                  return Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]))
              }))

          for(let i in groups[key]){
              //console.log(groups[key][i].created_at)
              let arr = groups[key][i].created_at.split(/[- :]/)
              //console.log(arr)

              //alert(Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]))+':'+thisGroupNewestDate)
              if(Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5])) === thisGroupNewestDate) {
                  resultArr.push(groups[key][i])
              }
          }
      })

      //console.log(ar,resultArr)
      // スコアデータを数値化
      var score = 0;
      //trustdockに登録していたらポイント加算
      if(isTrustdockResult) {
          for(let i in resultArr) {
              for(let n in resultArr[i]["tag"]) {
                  let domain = resultArr[i]["domain"];
                  let tag = resultArr[i]["tag"][n];
                  if (points[domain][n][tag]) {
                      // ポイント表(pointsテーブル)に沿ってスコアを加算
                      score += parseInt(points[domain][n][tag], 10);
                      //console.log(points[domain][n][tag],tag)
                  }
              }
          }
      }
      if(scoreEval) {
        score += scoreEval;
      }
      //console.log(score)
      //console.log("score=" + score);

      switch(true) {
          case score >= 200:
              // Gold(200~)
              scope.setState({rank: "Gold"});
              scope.setState({rank_img: "/img/common/prof_gold.png"});
              scope.setState({rank_class: "font-en rank-gold"});
              scope.setState({rank_class_jp: "font-jp rank-gold"});
              scope.setState({rank_jp: "ゴールド"});
              scope.setState({rank_chart: "/img/common/rank_4.png"});
              scope.setState({rating_str:scope.state.displayName + 'さんは、日常的にシェアリングエコノミーサービスを使用する上級者です。シェアリングエコノミーサービスの仕組みを十分に理解していると言えそうです。実績は申し分ありませんので、安心して取引することができるでしょう。'});
              break;
          case score >= 100 && score < 200 :
              // Silver(100~200)
              scope.setState({rank: "Silver"});
              scope.setState({rank_img: "/img/common/prof_silver.png"});
              scope.setState({rank_class: "font-en rank-silver"});
              scope.setState({rank_class_jp: "font-jp rank-silver"});
              scope.setState({rank_jp: "シルバー"});
              scope.setState({rank_chart: "/img/common/rank_3.png"});
              scope.setState({rating_str:scope.state.displayName + 'さんは、シェアリングエコノミーサービスの愛用者です。シェアリングエコノミーサービスの仕組みを十分に理解していると言えそうです。十分な実績がありますので、スムーズな取引が見込めるでしょう。'});
              break;
          case score >= 10 && score < 100 :
              // Bronze(10~100)
              scope.setState({rank: "Bronze"});
              scope.setState({rank_img: "/img/common/prof_bronze.png"});
              scope.setState({rank_class: "font-en rank-bronze"});
              scope.setState({rank_class_jp: "font-jp rank-bronze"});
              scope.setState({rank_jp: "ブロンズ"});
              scope.setState({rank_chart: "/img/common/rank_2.png"});
              scope.setState({rating_str:scope.state.displayName + 'さんは、シェアリングエコノミーサービスを利用中です。実績を積んでいる最中ですので、不慣れな点はあるかもしれません。現在の実績から、信用に足る人物であることを確認した上で取引しましょう。'});
              break;
          default:
              // Beginner(0~10)
              scope.setState({rank: "Beginner"});
              scope.setState({rank_img: "/img/common/prof_beginner.png"});
              scope.setState({rank_class: "font-en rank-biginner"});
              scope.setState({rank_class_jp: "font-jp rank-biginner"});
              scope.setState({rank_jp: "ビギナー"});
              scope.setState({rank_chart: "/img/common/rank_1.png"});
              scope.setState({rating_str:scope.state.displayName + 'さんは、シェアリングエコノミーサービスに関しては初心者です。取引をするにはリスクがありますので、現在の実績を確認した上で取引しましょう。'});
      }

      // タグ
      for(let i in resultArr) {
        let domain = resultArr[i]["domain"];

        if ("yahoo_auction" === domain) {
          let arr = [];
          for(let n in resultArr[i]["tag"]) {
            arr.push(resultArr[i]["tag"][n])
          }
          scope.setState({ yahoo_auction: arr })
        }

        if ("coconala" === domain) {
          let arr = [];
          for(let n in resultArr[i]["tag"]) {
            arr.push(resultArr[i]["tag"][n])
          }
          scope.setState({ coconala: arr })
        }

        if ("anyca" === domain) {
          let arr = [];
          for(let n in resultArr[i]["tag"]) {
            arr.push(resultArr[i]["tag"][n])
          }
          scope.setState({ anyca: arr })
        }

        if ("notteco" === domain) {
          let arr = [];
          for(let n in resultArr[i]["tag"]) {
            arr.push(resultArr[i]["tag"][n])
          }
          scope.setState({ notteco: arr })
        }

        if ("spacemarket" === domain) {
          let arr = [];
          for(let n in resultArr[i]["tag"]) {
            arr.push(resultArr[i]["tag"][n])
          }
          scope.setState({ spacemarket: arr })
        }
        //20180425 rakuma
        if ("rakuma" === domain) {
          let arr = [];
          for(let n in resultArr[i]["tag"]) {
            arr.push(resultArr[i]["tag"][n])
          }
          scope.setState({ rakuma: arr })
        }
        //20180514 minne
        if ("minne" === domain) {
          let arr = [];
          for(let n in resultArr[i]["tag"]) {
            arr.push(resultArr[i]["tag"][n])
          }
          scope.setState({ minne: arr })
        }                     
      }
    }    
} 
//連携サービス取得処理
export const getUserService = (uid,scope,snapshot) => {
      if (null != snapshot.ids) {
        //console.log(snapshot.ids);
        if (null != snapshot.ids.yahoo_auction) {
            scope.setState({yahoo_auction_status: true});
            if ("true" === snapshot.ids.yahoo_auction.connect) {
              // scoreデータがあればチェックマークを表示
              scope.setState({yahooauction_class: "icon-add-record record-connect clearfix"});
              scope.setState({yahooauction_on: true});
              let popup_count = (scope.state.popup_count % 4) + 1;
              scope.setState({popup_count: popup_count});
              scope.setState({yahooauction_popup_count: popup_count});
            } else if ("false" === snapshot.ids.yahoo_auction.connect) {
              // scoreデータが空白ならば連携ミス
              scope.setState({yahooauction_class: "icon-add-record record-error clearfix"});
              scope.setState({yahooauction_on: false});
            } else {
              scope.setState({yahooauction_class: "icon-add-record record-load clearfix"});
              scope.setState({yahooauction_on: false});
            }
        } else {
            scope.setState({yahooauction_class: "icon-add-record clearfix"});
            scope.setState({yahooauction_on: false});
        }
        if (null != snapshot.ids.coconala) {
            scope.setState({coconala_status: true});
            if ("true" === snapshot.ids.coconala.connect) {
              // scoreデータがあればチェックマークを表示
              scope.setState({coconala_class: "icon-add-record record-connect clearfix"});
              scope.setState({coconala_on: true});
              let popup_count = (scope.state.popup_count % 4) + 1;
              scope.setState({popup_count: popup_count});
              scope.setState({coconala_popup_count: popup_count});
            } else if ("false" === snapshot.ids.coconala.connect) {
              // scoreデータが空白ならば連携ミス
              scope.setState({coconala_class: "icon-add-record record-error clearfix"});
              scope.setState({coconala_on: false});
            } else {
              scope.setState({coconala_class: "icon-add-record record-load clearfix"});
              scope.setState({coconala_on: false});
            }
        } else {
            scope.setState({coconala_class: "icon-add-record clearfix"});
            scope.setState({coconala_on: false});
        }
        if (null != snapshot.ids.anyca) {
            scope.setState({anyca_status: true});
            if ("true" === snapshot.ids.anyca.connect) {
              // scoreデータがあればチェックマークを表示
              scope.setState({anyca_class: "icon-add-record record-connect clearfix"});
              scope.setState({anyca_on: true});
              let popup_count = (scope.state.popup_count % 4) + 1;
              scope.setState({popup_count: popup_count});
              scope.setState({anyca_popup_count: popup_count});
            } else if ("false" === snapshot.ids.anyca.connect) {
              // scoreデータが空白ならば連携ミス
              scope.setState({anyca_class: "icon-add-record record-error clearfix"});
              scope.setState({anyca_on: false});
            } else {
              scope.setState({anyca_class: "icon-add-record record-load clearfix"});
              scope.setState({anyca_on: false});
            }
        } else {
            scope.setState({anyca_class: "icon-add-record clearfix"});
            scope.setState({anyca_on: false});
        }
        if (null != snapshot.ids.notteco) {
            scope.setState({notteco_status: true});
            if ("true" === snapshot.ids.notteco.connect) {
              // scoreデータがあればチェックマークを表示
              scope.setState({notteco_class: "icon-add-record record-connect clearfix"});
              scope.setState({notteco_on: true});
              let popup_count = (scope.state.popup_count % 4) + 1;
              scope.setState({popup_count: popup_count});
              scope.setState({notteco_popup_count: popup_count});
            } else if ("false" === snapshot.ids.notteco.connect) {
              // scoreデータが空白ならば連携ミス
              scope.setState({notteco_class: "icon-add-record record-error clearfix"});
              scope.setState({notteco_on: false});
            } else {
              scope.setState({notteco_class: "icon-add-record record-load clearfix"});
              scope.setState({notteco_on: false});
            }
        } else {
            scope.setState({notteco_class: "icon-add-record clearfix"});
            scope.setState({notteco_on: false});
        }
        if (null != snapshot.ids.spacemarket) {
            scope.setState({spacemarket_status: true});
            if ("true" === snapshot.ids.spacemarket.connect) {
              // scoreデータがあればチェックマークを表示
              scope.setState({spacemarket_class: "icon-add-record record-connect clearfix"});
              scope.setState({spacemarket_on: true});
              let popup_count = (scope.state.popup_count % 4) + 1;
              scope.setState({popup_count: popup_count});
              scope.setState({spacemarket_popup_count: popup_count});
            } else if ("false" === snapshot.ids.spacemarket.connect) {
              // scoreデータが空白ならば連携ミス
              scope.setState({spacemarket_class: "icon-add-record record-error clearfix"});
              scope.setState({spacemarket_on: false});
            } else {
              scope.setState({spacemarket_class: "icon-add-record record-load clearfix"});
              scope.setState({spacemarket_on: false});
            }
        } else {
            scope.setState({spacemarket_class: "icon-add-record clearfix"});
            scope.setState({spacemarket_on: false});
        }
        //20180425 rakuma
        // if (null != snapshot.ids.rakuma) {
        //     //TODO 他サービスも含めこのstate何？？？
        //     //scope.setState({rakuma_status: true});
        //     if ("true" === snapshot.ids.rakuma.connect) {
        //       // scoreデータがあればチェックマークを表示
        //       scope.setState({rakuma_class: "icon-add-record record-connect clearfix"});
        //       scope.setState({rakuma_on: true});
        //       let popup_count = (scope.state.popup_count % 4) + 1;
        //       scope.setState({popup_count: popup_count});
        //       scope.setState({rakuma_popup_count: popup_count});
        //     } else if ("false" === snapshot.ids.rakuma.connect) {
        //       // scoreデータが空白ならば連携ミス
        //       scope.setState({rakuma_class: "icon-add-record record-error clearfix"});
        //       scope.setState({rakuma_on: false});
        //     } else {
        //       scope.setState({rakuma_class: "icon-add-record record-load clearfix"});
        //       scope.setState({rakuma_on: false});
        //     }
        // } else {
        //     scope.setState({rakuma_class: "icon-add-record clearfix"});
        //     scope.setState({rakuma_on: false});
        // }
        //20180514 minne
        if (null != snapshot.ids.minne) {
            //TODO 他サービスも含めこのstate何？？？
            //scope.setState({minne_status: true});
            if ("true" === snapshot.ids.minne.connect) {
              // scoreデータがあればチェックマークを表示
              scope.setState({minne_class: "icon-add-record record-connect clearfix"});
              scope.setState({minne_on: true});
              let popup_count = (scope.state.popup_count % 4) + 1;
              scope.setState({popup_count: popup_count});
              scope.setState({minne_popup_count: popup_count});
            } else if ("false" === snapshot.ids.minne.connect) {
              // scoreデータが空白ならば連携ミス
              scope.setState({minne_class: "icon-add-record record-error clearfix"});
              scope.setState({minne_on: false});
            } else {
              scope.setState({minne_class: "icon-add-record record-load clearfix"});
              scope.setState({minne_on: false});
            }
        } else {
            scope.setState({minne_class: "icon-add-record clearfix"});
            scope.setState({minne_on: false});
        }     
                      
      } else {
        //default
        scope.setState({yahooauction_class: "icon-add-record clearfix"});
        scope.setState({coconala_class: "icon-add-record clearfix"});
        scope.setState({anyca_class: "icon-add-record clearfix"});
        scope.setState({notteco_class: "icon-add-record clearfix"});
        scope.setState({spacemarket_class: "icon-add-record clearfix"});
        //20180425 rakuma
        // scope.setState({rakuma_class: "icon-add-record clearfix"});
        //20180514 minne
        scope.setState({minne_class: "icon-add-record clearfix"});
        scope.setState({yahooauction_on: false});
        scope.setState({coconala_on: false});
        scope.setState({anyca_on: false});
        scope.setState({notteco_on: false});
        scope.setState({spacemarket_on: false});
        //20180425 rakuma
        // scope.setState({rakuma_on: false});
        //20180514 minne
        scope.setState({minne_on: false}); 
      }
}



// WEBPACK FOOTER //
// ./src/functions/getUserRank.js